import React from 'react';
import {useModelEditPermissionsSideBarModal} from './useModelEditPermissionsSideBarModal';
import {ModelActionProps} from '../../../../actionMenuTypes';
import {MODEL_ACTION_MENU_IDS} from '../../../../../../test/types';
import SideBarButtonItem from '../../../../../layout/common/SideBarButtonItem';
import {tid} from '../../../../../../testUtils';
import {canEditModel} from '../../../../../../permissions/usePermissions';
import {Password16} from '@carbon/icons-react';
import {UnlockOutlined} from '@ant-design/icons';
import {getModelSteward, isModelExternal, useModelDetail} from '../../../../../../store/model';
import {useNavigate} from 'react-router-dom';
import {getUrlRoute, MRAppRoutes} from '../../../../../router/routes';

const ModelEditPermissionsActionMenuButton: React.FC<Partial<ModelActionProps>> = (props) => {
  const navigate = useNavigate();
  const {ModalComponent, openModal} = useModelEditPermissionsSideBarModal(props);
  const externalModel = isModelExternal(props.model);
  const modelDetails = useModelDetail(props.model?.uuid);
  const modelSteward = modelDetails ? getModelSteward(modelDetails) : null;
  const disabledExternalModel = (modelSteward === null || modelDetails?.vestLead === null) && externalModel;

  const handleClick = (event?: any) => {
    if (disabledExternalModel) {
      return;
    }
    if (props.newDesign && props.model?.uuid) {
      navigate(
        getUrlRoute(MRAppRoutes.MODEL_UPLOAD, {
          uuid: props.model.uuid,
          editMode: 'true',
          editStep: 'permissions',
        } as any),
      );
      return;
    }
    openModal(event);
  };

  return (
    <>
      <SideBarButtonItem
        {...tid(MODEL_ACTION_MENU_IDS.EDIT_PERMISSIONS)}
        permission={canEditModel(props.model)}
        onClick={handleClick}
        //disabled={disabledExternalModel}
        icon={props.newDesign ? <UnlockOutlined /> : <Password16 />}
        text="Edit Model Access"
        disabledExternalModel={disabledExternalModel}
        disabledToolTipName="Missing VEST or VEAM Lead & HEDS Lead Info"
      />
      {!props.newDesign && ModalComponent}
    </>
  );
};

export default ModelEditPermissionsActionMenuButton;
